var map = {
	"./police/←.png": 1679,
	"./police/↑.png": 1302,
	"./police/→.png": 3897,
	"./police/↓.png": 3602,
	"./super/←.png": 3106,
	"./super/↑.png": 3663,
	"./super/→.png": 2608,
	"./super/↓.png": 2029,
	"./taxi/←.png": 7397,
	"./taxi/↑.png": 7362,
	"./taxi/→.png": 3823,
	"./taxi/↓.png": 7738
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5404;